import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class GroupComponent extends Vue {
    groupList: Array<any> = [];
    listLoading: Boolean = false;
    editLoading: Boolean = false;
    editList: Array<any> = [];
    editName: String = '';
    dialogGroup: Boolean = false;
    groupRadio: String = '';
    txtNewGroup: string = '';
    selOldGroup: string = '';
    visibleNewGroup: String = 'visibleGroup';
    visibleOldGroup: String = 'visibleGroup';
    addItemGroup: Object = null;
    btnDelete: Boolean = true;
    btnUpdate: Boolean = true;
    changeBeforeList: Array<any> = [];
    isDisable: Boolean = false;

    handleSelectionChange(val) {
        this.editList = val;
        let seleList = this.editList;
        let isClose = false;
        let isOpen = false;
        if (seleList.length > 0) {
            this.btnDelete = false;
            this.btnUpdate = false;

        } else {
            this.btnDelete = true;
            this.btnUpdate = true;
        }
    }

    jump(url) {
        this.$router.push({
            path: url,
            query: {}
        });
    }

    selectGroup() {
        this.txtNewGroup = '';
        this.selOldGroup = '';
        if (this.groupRadio == '1') {
            this.visibleNewGroup = '';
            this.visibleOldGroup = 'visibleGroup';
        } else {
            this.visibleNewGroup = 'visibleGroup';
            this.visibleOldGroup = '';
        }
    }

    onAddGroup() {

       
        if (this.addItemGroup != null) {
            this.$message({
                message: '完成当前操作才能再次添加',
                type: 'warning'
            });
            return;
        }

        this.addItemGroup = {
            'accountId': '',
            'createTime': new Date(),
            'groupId': '',
            'groupName': '',
            'teachersNum': '',
            'vlbInput': true,
            'vlbSpan': false,
            'vlbEditSpan': false
        };

        let arrList = [];
        arrList.push(this.addItemGroup);

        this.groupList.forEach(item => {
            arrList.push(item);
        })

        this.groupList = arrList;
        this.groupList.push({});
        this.groupList.pop();

        this.isDisable = true;
    }

    onGropSubmit() {

        let groupId = '';
        if (this.groupRadio == '1') {
            let groupName = this.txtNewGroup;
            this.txtNewGroup = '';
            let para;
            para = {
                "GroupName": groupName
            };

            if (!/^[\S]{2,20}$/.test(groupName)) {
                this.$message({
                    message: '分组名为2-20位字符，中文，英文，数字及符号（无空格）',
                    type: 'error'
                });

                return false;
            }

            this.IsRepeat(groupName, '', '', () => {
                this.axios.post('/api/groups?GroupName=' + encodeURIComponent(groupName), para).then((data) => {
                    groupId = data.data;
                    this.updataTeacherGroup(groupId);
                })
            });


        } else if (this.groupRadio == '2') {
            groupId = this.selOldGroup;
            this.selOldGroup = '';
            this.updataTeacherGroup(groupId);
        }
    }

    updataTeacherGroup(groupId) {
        let ids = [];

        this.editList.forEach(item => {
            ids.push(item.groupId);
        });

        let strId = ids.join(',');
        this.axios.put('/api/groups/teachergroup/' + groupId + '?groupIds=' + strId).then((data) => {
            this.getGroupList();
        })

        this.editList = [];
        this.dialogGroup = false;
    }

    oneditName(row) {
        if (this.changeBeforeList.length < 1) {
            this.changeBeforeList.push({
                groupName: row.groupName,
                groupId: row.groupId
            });
            row.vlbInput = true;
            row.vlbSpan = false;
        }
    }

    closeEdit(row) {
        row.vlbInput = false;
        row.vlbSpan = true;
    }

    onInputBlur(row) {

        let currGroupName = '';
        let currGroupId = '';
        if (this.changeBeforeList.length > 0) {
            currGroupName = this.changeBeforeList[0].groupName;
            currGroupId = this.changeBeforeList[0].groupId;
        }
        this.changeBeforeList = [];
        if (row.groupName != '' && currGroupName == row.groupName && currGroupId == row.groupId) {

            this.closeEdit(row);
            return;
        }

        if (row.groupName == '') {
            this.$message({
                message: '请添加教师分组名称',
                type: 'error'
            });
            return false;
        }
        else if (!/^[\S]{2,20}$/.test(row.groupName)) {
            this.$message({
                message: '分组名为2-20位字符，中文，英文，数字及符号（无空格）',
                type: 'error'
            });
            return false;
        }
        this.IsRepeat(row.groupName, currGroupName, currGroupId, () => {
            let gName = encodeURIComponent(row.groupName);
            let url = '';
            let message = '';
            let action = '';
            if (row.groupId == '') {
                url = '/api/groups?GroupName=' + gName;
                message = '添加';
                action = 'post';
            } else {
                url = '/api/groups/' + row.groupId + '?groupName=' + gName;
                message = '修改';
                action = 'put';
            }
            this.axios[action](url).then((data) => {
                this.isDisable = false;
                if (data == undefined) {
                    this.$message({
                        message: message + '失败',
                        type: 'error'
                    });
                } else {
                    this.$message({
                        message: message + '成功',
                        type: 'success'
                    });
                    this.getGroupList();
                }
            }).catch((error) => {
                this.$message({
                    message: message + '失败',
                    type: 'error'
                });
            })
        })


        console.log(12);
    }

    getGroupList() {
        this.addItemGroup = null;

        this.axios.get('/api/groups').then((data) => {
            let itemData = data.data;
            itemData.forEach(item => {
                item.vlbInput = false;
                item.vlbSpan = true;
                item.vlbEditSpan = true;
            })
            this.groupList = data.data;
        });
        this.isDisable = false;
    }

    onUpdateGroup() {
        if (this.editList.length <= 0) {
            this.$alert("请选择要删除的分组", "提示");
            return false;
        }
        this.dialogGroup = true;
    }

    onDelGroup() {
        if (this.editList.length <= 0) {
            this.$alert("请选择要删除的分组", "提示");
            return false;
        }

        let ids = [];

        this.editList.forEach(item => {
            ids.push(item.groupId);
        });

        let strId = ids.join(',');

        let _this = this;
        this.axios({
            method: 'delete',
            url: '/api/groups/' + strId,
            transformResponse: [function (data) {
                // 对 data 进行任意转换处理

                if (data == "\"ok\"") {
                    _this.$message({
                        message: '删除成功',
                        type: 'success'
                    })
                    _this.getGroupList();
                }
            }],
            validateStatus: function (status) {
                if (status != 200) {
                    if (status == 404) {
                        _this.$message({
                            message: '教师分组不存在',
                            type: 'error'
                        })
                    } else if (status == 412) {
                        _this.$message({
                            message: '请将分组中的教师账号转移至其他分组后，再删除',
                            type: 'error'
                        })
                    }

                }
            },
        });
    }

    IsRepeat(groupName, currGroupName, currGroupId, callback) {
        groupName = encodeURIComponent(groupName);
        this.axios.get('/api/groups/existgroup?groupName=' + groupName).then((data) => {
            if (data.status == 200) {
                if (!data.data) {
                    callback && callback();
                    return;
                }
            }
            this.changeBeforeList.push({
                groupName: currGroupName,
                groupId: currGroupId
            });
            this.$message({
                message: '已存在该分组',
                type: 'warning'
            });
        }).catch((error) => {
            this.changeBeforeList.push({
                groupName: currGroupName,
                groupId: currGroupId
            });
            this.$message({
                message: '接口出错',
                type: 'warning'
            });
        })
    }

    //声明周期
    mounted() {
        this.getGroupList();
    }
}